import { BirthdayDocument } from 'shell/view-models/birthday-document';
import { Document } from 'shell/models/person/document';

export const transformBirthdayDocument = (
  values: BirthdayDocument | undefined
): Document | undefined => {
  if (
    !(
      values?.year ||
      values?.municipality ||
      values?.documentDate ||
      values?.documentNumber ||
      values?.portion ||
      values?.serie ||
      values?.transcript ||
      values?.townHallOffice ||
      values?.volume
    )
  ) {
    // se non ci sono dati
    return undefined;
  }

  const returnData: Document | undefined = values
    ? {
        anno: values?.year || undefined,
        comuneRegistrazione: values?.municipality
          ? {
              codiceIstat: values?.municipality?.id || undefined,
              descrizioneLocalita: values?.location || undefined,
              nomeComune: values?.municipality?.description || undefined,
              siglaProvinciaIstat: values?.municipality?.province || undefined,
            }
          : undefined,
        dataFormazioneAtto: values?.documentDate?.toFormat('yyyy-MM-dd') || undefined,
        numeroAtto: values?.documentNumber || undefined,
        parte: values?.portion || undefined,
        serie: values?.serie || undefined,
        trascritto: values?.transcript ? '1' : '0',
        ufficioMunicipio: values?.townHallOffice || undefined,
        volume: values?.volume || undefined,
      }
    : undefined;

  return returnData;
};
